import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps, Image } from 'react-native'
import { useBuilding, useLocation } from 'zens-store'
import { Color, Icon, Radius, Spacing, Text } from 'zens-storybook'
import Placeholder from '@dms/../assets/images/placeholder.png'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.simplyWhite,
    padding: Spacing.S,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: Spacing.XS,
  },
  location: {
    color: Color.metalGrey,
    marginLeft: Spacing.XS,
  },
  image: {
    width: '100%',
    height: 210,
    marginBottom: Spacing.S,
    borderRadius: Radius.M,
  },
})

interface Props extends ViewProps {
  companyId: number
  buildingId: number
}

const InsightsBuilding = (props: Props) => {
  const { companyId, buildingId, style, ...otherProps } = props
  const building = useBuilding({ companyId, buildingId })
  const { name, locationId = 0, numberOfWorkspaces: count = 0, src } = building.data || {}
  const location = useLocation({ companyId, locationId })
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Image source={{ uri: src }} style={styles.image} defaultSource={Placeholder} />
      <Text level={5}>{name}</Text>
      <View style={styles.row}>
        <Icon name="marker" color={Color.metalGrey} />
        <Text level={6} style={styles.location} numberOfLines={1}>
          {building.data?.displayAddress || location.data?.displayAddress}
        </Text>
      </View>
      <Text>
        <Trans count={count}>{{ count }} workspaces</Trans>
      </Text>
    </View>
  )
}

interface SkeletonProps extends ViewProps {}
InsightsBuilding.Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Image source={Placeholder} style={styles.image} />
      <Text.Skeleton />
      <Text.Skeleton style={styles.row} level={4} />
      <Text.Skeleton />
    </View>
  )
}

export default InsightsBuilding
